import React, {Component} from "react";
import './index.less'
export default class PortalContentScene extends Component{
    constructor(props) {
        super(props)
        this.state = {
            selectedIndex:1,
            datas:[
                {
                    id:1,
                    title:"智能客服机器人",
                    desc1:"应用业务 | 广联达造价全产品线-广小二",
                    desc2:"机器人可7*24小时解决用户疑问，分担人工客服工作量，重点突破重复问题的解答，从而实现降本增效，提升服务满意度。",
                },
                {
                    id:2,
                    title:"智能助理机器人",
                    desc1:"应用业务 | 广联达数字项目产品线-广联达数字项目智能助理",
                    desc2:"提供业务信息查询服务，统一某业务场景下的咨询渠道，便利用户信息的获取，节省时间。",
                },
                {
                    id:3,
                    title:"任务服务机器人",
                    // desc1:"应用业务 | 广联达造价全产品线",
                    desc2:"提供人机对话服务，机器人可根据用户语音输入的指令，执行相应的操作。解放双手，高效完成任务。",
                }
            ]
        }
    }

    handleMouseEnter = (id) => {
        this.setState({selectedIndex:id})
    }

    render() {
        let { selectedIndex , datas } = this.state
        let { handleMouseEnter } = this
        return (
            <div className={'portal-content-scene'}>
                <div className={'portal-content-scene-content w1200'} id={'portalScene'}>
                    <h2>应用场景</h2>
                    <div style={{display:"flex"}}>
                        <ul style={{flex:1}}>
                            {
                                datas.map(ele => {
                                    return (
                                        <li key={ele.id} onMouseEnter={() => {handleMouseEnter(ele.id)}}>
                                            {
                                                ele.id === selectedIndex ?
                                                    <div className={"scene-selected"}>
                                                        <h3 style={{color:'white',height:30,}}>{ele.title}</h3>
                                                        <p style={{color:'white',height:30,whiteSpace:'nowrap'}}>{ele.desc1}</p>
                                                        <p style={{width:338,color:'white'}}>{ele.desc2}</p>
                                                        <span className={'scene-selected-arrow'}></span>
                                                    </div>:
                                                    <div>
                                                        <h3 style={{color:'#5c75ff',height:30}}>{ele.title}</h3>
                                                        {
                                                            ele.desc1 ? <p style={{color:"#333333",height:30,whiteSpace:'nowrap'}}>{ele.desc1}</p> : null
                                                        }
                                                        <p style={{width:338,color:"#666666"}}>{ele.desc2}</p>
                                                    </div>
                                            }
                                        </li>
                                    )
                                })
                            }
                            
                        </ul>
                        <div style={{width:750}}>
                            <img src={require(`./images/${selectedIndex}.png`)} width={750} height={450} alt=""/>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}